<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <comment-icon class="tw-h-6 tw-w-6 tw-text-primary-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-2 sm:tw-ml-4 sm:tw-text-left tw-w-full">
          <h3 class="tw-text-xl tw-font-thin">Add Note</h3>
          <base-form ref="noteForm" class="tw-mt-6 tw-w-full">
            <base-textarea v-model="newNote" class="tw-mb-2 tw-w-full" required :maxlength="125" />
          </base-form>
        </div>
      </div>
      <inline-error id="create-rx-note-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="createNote" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="primary">Add</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="primary">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { CommentIcon } from "@/assets/svgs";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPrescriptionCreateNote",
  components: {
    CommentIcon,
    InlineError,
  },
  props: {
    businessId: String,
    userId: String,
    businessPrescriptionId: String,
  },
  data() {
    return {
      newNote: null,
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.newNote = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    createNote() {
      if (!this.$refs.noteForm.validate()) return;
      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/members/${this.userId}/prescriptions/note`, {
          businessPrescriptionId: this.businessPrescriptionId,
          note: this.newNote,
        })
        .then(() => {
          this.reset();
          this.$emit("updated");
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Failed to save note`;
          this.errorMessage = `There was an error saving this note. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
